"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("@/common/functions");
function default_1() {
    window.history.length > 1 ? window.history.back() : (0, functions_1.goToMain)();
}
exports.default = default_1;
